import { render, staticRenderFns } from "./CurrentFamily.vue?vue&type=template&id=b69cc56e&scoped=true&"
import script from "./CurrentFamily.vue?vue&type=script&lang=js&"
export * from "./CurrentFamily.vue?vue&type=script&lang=js&"
import style0 from "./CurrentFamily.vue?vue&type=style&index=0&id=b69cc56e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69cc56e",
  null
  
)

export default component.exports